module.exports = function () {
    // Smoothscroll
    $('a').click(function () {
        if ('a' + location.pathname.replace(/^\//, '').replace(/\/$/, '') == 'a' + this.pathname.replace(/^\//, '').replace(/\/$/, '') && location.hostname == this.hostname) {
            var offset = 0;
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top - offset
                }, 350);
                return false;
            }
        }
    });
}